module.exports = __webpack_public_path__ + "static/media/step4@2x.dcf03825.webm";